import { render, staticRenderFns } from "./OrderAmountSituation.vue?vue&type=template&id=1d079170&scoped=true"
import script from "./OrderAmountSituation.vue?vue&type=script&lang=js"
export * from "./OrderAmountSituation.vue?vue&type=script&lang=js"
import style0 from "./OrderAmountSituation.vue?vue&type=style&index=0&id=1d079170&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d079170",
  null
  
)

export default component.exports